import {Component, Input} from '@angular/core';
import {IShareList} from '../social-models';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {Util} from "../../util/util";
import {Constants} from "../../constants";
import {GqlShareListService} from "../share-list/gql-share-list.service";

@Component({
    selector: 'phx-create-share-list-modal',
    templateUrl: './create-share-list-modal.component.html',
    styleUrls: ['./create-share-list-modal.component.scss'],
    standalone: false
})
export class CreateShareListModalComponent {

    @Input() shareList: IShareList = { listName: '' } as IShareList;

    constructor(
        private gqlShareListService: GqlShareListService,
        private bsModalRef: BsModalRef
    ) { }

    saveShareList(navigateToEnrollment: boolean) {
        this.shareList.singleUse = false;
        this.gqlShareListService.updateShareList(this.shareList).subscribe(() => {
            if (navigateToEnrollment) {
                Util.redirectInternal(Constants.URL_HUB, '/#/directEnrollment', false);
            } else {
                this.bsModalRef.hide();
            }
        });
    }

    cancel() {
        this.bsModalRef.hide();
    }
}
